import { FormPayload as OrganizationFormPayload } from 'components/SubscriptionOrganizationForm/interfaces';
import { FormPayload as SubscriptionSettingsFormPayload } from 'components/SubscriptionSettingsForm/interfaces';
import { ModuleTypes } from 'enums';

export enum SubscriptionStep {
  modules,
  organization,
  confirmEmail,
  settings,
}

export interface StorageSubscription {
  selectedModules?: ModuleTypes[];
  userCount?: number;
  step?: SubscriptionStep;
  organizationForm?: OrganizationFormPayload;
  settingsForm?: SubscriptionSettingsFormPayload;
}
